import { render } from "./LocationLatestStatusView.vue?vue&type=template&id=ca37dc9c&scoped=true"
import script from "./LocationLatestStatusView.vue?vue&type=script&lang=js"
export * from "./LocationLatestStatusView.vue?vue&type=script&lang=js"

import "./LocationLatestStatusView.vue?vue&type=style&index=0&id=ca37dc9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca37dc9c"]])

export default __exports__